import React from "react";
import {
  ActivePageButton,
  NavButton,
  NavButtonsContainer,
  PageButton,
  PageContainer,
  PaginatorContainer,
} from "./Paginator.styles";
import { PaginatorProps } from "./Paginator.types";
import Dropdown from "../Dropdowns/Dropdown";

const Paginator: React.FC<PaginatorProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  pageSize,
  onPageSizeChange,
  rowAmountOptions,
}) => {
  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= totalPages) {
      onPageChange(newPage);
    }
  };

  const renderPages = () => {
    const pages: React.ReactNode[] = [];

    pages.push(
      currentPage === 1 ? (
        <ActivePageButton key={1} type="button" aria-current="page">1</ActivePageButton>
      ) : (
        <PageButton key={1} type="button" onClick={() => handlePageChange(1)}>1</PageButton>
      ),
    );

    if (currentPage > 4) {
      pages.push(<span key="start-ellipsis">…</span>);
    }

    const startPage = Math.max(2, currentPage - 1);
    const endPage = Math.min(totalPages - 1, currentPage + 1);
    for (let page = startPage; page <= endPage; page += 1) {
      pages.push(
        currentPage === page ? (
          <ActivePageButton key={page} type="button" aria-current="page">
            {page}
          </ActivePageButton>
        ) : (
          <PageButton key={page} type="button" onClick={() => handlePageChange(page)}>
            {page}
          </PageButton>
        ),
      );
    }

    if (currentPage < totalPages - 3) {
      pages.push(<span key="end-ellipsis">…</span>);
    }

    if (totalPages > 1) {
      pages.push(
        currentPage === totalPages ? (
          <ActivePageButton key={totalPages} type="button" aria-current="page">
            {totalPages}
          </ActivePageButton>
        ) : (
          <PageButton key={totalPages} type="button" onClick={() => handlePageChange(totalPages)}>
            {totalPages}
          </PageButton>
        ),
      );
    }

    return pages;
  };

  return (
    <PaginatorContainer>
      <Dropdown
        options={rowAmountOptions}
        selectedValue={pageSize}
        onChange={onPageSizeChange}
      />

      <NavButtonsContainer>
        <NavButton
          type="button"
          disabled={currentPage <= 1}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Назад
        </NavButton>
        <PageContainer>{renderPages()}</PageContainer>
        <NavButton
          type="button"
          disabled={currentPage >= totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Вперёд
        </NavButton>
      </NavButtonsContainer>
    </PaginatorContainer>
  );
};

export default Paginator;
